import { ProfileWithEvents } from './models';

const normalizeEvents = (events = '') =>
  events
    .split(';')
    .map((e) => e.trim())
    .filter(Boolean);

export const getEventsString = (profile: ProfileWithEvents | null) =>
  profile?.userDetails.events.defaultValue ?? '';

export const isSubscribed = (events: string, uid: string) =>
  normalizeEvents(events).includes(uid);

export const addEvent = (events: string, uid: string) =>
  isSubscribed(events, uid) ? events : `${events}${uid};`;

export const isProfileWithEvents = (
  data: unknown
): data is ProfileWithEvents => {
  if (!data || typeof data !== 'object') return false;

  const { userDetails } = data as Record<string, unknown>;
  if (!userDetails || typeof userDetails !== 'object') return false;

  const { events } = userDetails as Record<string, unknown>;
  if (!events || typeof events !== 'object') return false;

  const { defaultValue } = events as Record<string, unknown>;

  return typeof defaultValue === 'string' || defaultValue === undefined;
};

export const removeEvent = (eventUid: string, eventsStr = '') => {
  const result = normalizeEvents(eventsStr)
    .filter((e) => e !== eventUid)
    .join(';');

  return result ? `${result};` : '';
};

export const removeAllEvents = (): string => '';
